import { Button, Dialog, DialogContent, DialogActions, IconButton, Typography, Box, DialogTitle, Stack } from '@mui/material';
import { theme } from '../../../theme';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

interface ConfirmZoneSwitchModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  titleKey?: string;
  warningKey?: string;
}

const ConfirmZoneSwitchModal = ({ 
  open, 
  onClose, 
  onConfirm,
  titleKey = 'confirmZone',
  warningKey = 'zoneWarning',
}: ConfirmZoneSwitchModalProps) => {

  const { t } = useTranslation('stockCount');

  return (
    <Dialog
      maxWidth='sm'
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <WarningAmberIcon sx={{ color: theme.palette.warning.main, mr: 1 }} />
          <Typography variant="textLG">
            {t(titleKey)}
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.custom.gray[800],
            mr: '-10px',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box>
          <Typography 
            sx={{ 
              color: theme.palette.custom.gray[600],
              lineHeight: 1.5, 
            }}
          >
            {t(warningKey)}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ 
        padding: '0px 24px 24px', 
        '&.MuiDialogActions-root': {
          padding: '0px 24px 24px', 
        },
      }}>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='12px'
          width='100%'>
          <Button
            fullWidth
            variant="secondary"
            size="md"
            sx={{ fontSize: '16px' }} 
            onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button
            fullWidth
            sx={{ fontSize: '16px' }} 
            variant="primary"
            size="md"
            onClick={onConfirm} 
          >
            {t('continueAnyway')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmZoneSwitchModal;